<template>
  <b-form-group
    v-if="referer === 'UK'"
    class="postcode-lookup"
    :label="labelText"
  >
    <b-form-input
      class="my-3"
      v-model="postcodeLookup"
      @input="ukPostcodeLookup"
      :placeholder="placeholderText"
    ></b-form-input>
    <div v-if="postcodeResult && postcodeResult.length" class="postcode-dropdown">
      <ul>
        <li class="postcode-result"
          v-for="(address, index) in postcodeResult"
          :key="index"
          @click="handlePostcode(address.suggestion)"
        >
          {{ address.suggestion }}
        </li>
      </ul>
    </div>
    <p class="mb-0">Or enter address manually below</p>
  </b-form-group>
</template>

<script>
import { mapActions } from 'vuex'
import { postCodeLookup } from '../services/api'
import { selectPostcode } from '../helpers/index'
export default {
  props: {
    addressOwner: String,
    formName: String,
    labelText: String,
    isArray: Boolean,
    index: Number,
    arrayName: String,
    placeholderText: String
  },
  data () {
    return {
      postcodeResult: '',
      postcodeLookup: '',
      referer: window.siteVar.referer
    }
  },
  methods: {
    ...mapActions({
      selectAddressAction: 'authStore/selectAddressAction'
    }),
    async ukPostcodeLookup () {
      const res = await postCodeLookup(this.postcodeLookup)
      this.postcodeResult = res.data.results
    },
    handlePostcode (address) {
      const postCodeData = {
        address,
        postcode: this.postcodeLookup
      }
      this.$emit('postcodeSelected', postCodeData)
      if (this.formName !== 'addressUpdate') {
        this.selectPostcode(address, this.addressOwner, this.isArray, this.index, 'NOK', this.arrayName)
      }
      this.postcodeResult = []
    },
    selectPostcode
  }
}
</script>

<style scoped>
.postcode-lookup-input {
  position: relative;
}
.postcode-lookup {
  position: relative;
}
.postcode-dropdown {
  background-color: #fff;
  position: absolute;
  width: 100% !important;
  top: 40px !important;
  max-height: 200px;
  z-index: 10;
  border: 1px solid #4da3ff;
  overflow: auto;
}

@media only screen and (min-width: 992px) {
  .postcode-dropdown {
    right: 0;
    top: 50px;
    width: 70%;
  }    
  }

.postcode-dropdown ul {
  list-style: none;
    padding: 0;
}

.postcode-dropdown li {
  padding: 10px;
}

.postcode-result {
  transition: all .3s ease;
}

.postcode-result:hover {
  cursor: pointer;
  background-color: #4da3ff;
}

.manual-address {
  display: flex;
  justify-content: center;
}
.form-control {
  border: 1px solid #ced4da !important;
}
</style>
